import SubscribeForm from "@/components/feature/SubscribeForm";

export default function SubscribeSection() {
  return (
    <section id="subscribe" className="bg-foreground-950 py-16 md:py-20">
      <div className="mx-auto w-full max-w-shell px-4 md:px-8">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <p className="flex items-center gap-2 font-label text-xs tracking-[0.25em] text-accent-500">
              <span className="h-px w-6 bg-accent-500" />
              SUBSCRIBE
            </p>
            <h2 className="mt-3 font-heading text-2xl font-bold text-background-50 md:text-3xl">
              别再手动刷榜，让出圈话题主动找到你
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-background-300 md:text-base">
              留下邮箱，我们会在话题进入热搜前列、转发量出现异常增长时发一封提醒。每条提醒都包含热度值、转发量和当前扩散阶段，一分钟就能看完。
            </p>
            <ul className="mt-6 space-y-3">
              {[
                "只推送正在出圈的话题，不做无关打扰",
                "附上扩散时间线，一眼看清话题走到哪一步",
                "涉及人物全部匿名化，只讨论传播本身",
              ].map((item) => (
                <li key={item} className="flex items-start gap-2.5 text-sm text-background-200">
                  <i className="ri-checkbox-circle-fill mt-0.5 text-accent-500" />
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-lg border border-background-50/15 bg-background-50/5 p-5 backdrop-blur-sm md:p-7 lg:col-span-7">
            <h3 className="font-heading text-lg font-bold text-background-50">订阅热点更新</h3>
            <p className="mt-1.5 text-sm text-background-300">
              填写邮箱即可订阅，随时可以退订。
            </p>
            <SubscribeForm />
          </div>
        </div>
      </div>
    </section>
  );
}